import { gql, DocumentNode } from '@apollo/client';
import React from 'react';
import {
	InstallmentStatus,
	InvoiceViewPaymentInstallmentStatusFragment,
} from '#types';
import styles from './InvoiceViewPaymentInstallmentStatus.module.scss';
import { Status } from '../../../Status';
import Box from '@mui/material/Box';

const invoiceViewPaymentInstallmentStatusFragment = gql`
	fragment invoiceViewPaymentInstallmentStatus on PaymentInstallment {
		status
		scheduledPaymentDate
	}
`;

export type InvoiceViewPaymentInstallmentStatusProps = {
	installment?: InvoiceViewPaymentInstallmentStatusFragment;
	isCustomerOrAPPA?: boolean;
};

type InvoiceViewPaymentInstallmentStatusPropsWithFragment =
	React.FC<InvoiceViewPaymentInstallmentStatusProps> & {
		fragments: {
			invoiceViewPaymentInstallmentStatusFragment: DocumentNode;
		};
	};

const verbiageByStatus: Record<InstallmentStatus, string> = {
	[ InstallmentStatus.Disputed ]: 'Disputed',
	[ InstallmentStatus.FullyPaid ]: 'Paid',
	[ InstallmentStatus.FullyPaidPartiallyRefunded ]: 'Partial Refunded',
	[ InstallmentStatus.Pending ]: 'Paid',
	[ InstallmentStatus.Refunding ]: 'Refunding',
	[ InstallmentStatus.Refunded ]: 'Refunded',
	[ InstallmentStatus.Unpaid ]: 'Unpaid',
};

/**
 * This component manufactures it's appearance based entirely on PaymentInstallment.status except
 * for the "scheduled" state which comes from the PaymentInstallment.scheduledPaymentDate being set
 */
export const InvoiceViewPaymentInstallmentStatus: InvoiceViewPaymentInstallmentStatusPropsWithFragment =
	( { installment, isCustomerOrAPPA } ) =>
		installment?.status ? (
			<Box className={ styles.container }>
				<Status
					status={
						isCustomerOrAPPA &&
						installment.status === InstallmentStatus.Unpaid &&
						installment.scheduledPaymentDate
							? 'Scheduled'
							: verbiageByStatus[ installment.status ]
					}
					className={ styles.status }
				/>
			</Box>
		) : null;

InvoiceViewPaymentInstallmentStatus.fragments = {
	invoiceViewPaymentInstallmentStatusFragment,
};
